import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-denied",
    templateUrl: "./denied.component.html",
    styleUrls: ["./denied.component.scss"],
    standalone: false
})
export class AccessDeniedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
